<template>
  <div v-if="canView" class="report-card-container col-xl-4 col-lg-6 col-md-6 mb-4">
    <div class="report-card" @click="navigate">
      <div class="card-gradient"></div>
      <div class="card-body">
        <div class="card-icon-wrapper">
          <i :class="[icon || 'fas fa-file-alt', 'card-icon']"></i>
        </div>
        <div class="card-content">
          <h5 class="card-title">{{ title }}</h5>
          <p v-if="description" class="card-description">{{ description }}</p>
          <div class="card-action">
             <span>{{ btnText || Lang.get("messages.view_report") }}</span>
             <i class="fas fa-arrow-right ml-2 action-arrow"></i>
          </div>
        </div>
      </div>
      
      <!-- Decorative element -->
      <div class="card-decoration">
         <i :class="icon || 'fas fa-file-alt'"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportCard",
  props: {
    title: { type: String, required: true },
    description: { type: String, default: null },
    to: { type: String, default: null },
    btnText: { type: String, default: null },
    icon: { type: String, default: null },
    canView: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    navigate() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  }
};
</script>

<style scoped>
.report-card {
  position: relative;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: flex;
  flex-direction: column;
}

.report-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(29, 81, 102, 0.12);
  border-color: rgba(29, 81, 102, 0.1);
}

.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #1d5166, #3498db);
}

.card-body {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 0;
  z-index: 2;
}

.card-icon-wrapper {
  width: 56px;
  height: 56px;
  background: rgba(29, 81, 102, 0.08);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.report-card:hover .card-icon-wrapper {
  background: #1d5166;
  transform: rotate(5deg);
}

.card-icon {
  font-size: 24px;
  color: #1d5166;
  transition: all 0.3s ease;
}

.report-card:hover .card-icon {
  color: #df11118f;
}

.card-content {
  flex-grow: 1;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1.4;
}

.card-description {
  font-size: 0.85rem;
  color: #7f8c8d;
  margin-bottom: 16px;
  line-height: 1.5;
}

.card-action {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1d5166;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.action-arrow {
  transition: transform 0.3s ease;
}

.report-card:hover .action-arrow {
  transform: translateX(5px);
}

.card-decoration {
  position: absolute;
  bottom: -20px;
  right: -10px;
  font-size: 80px;
  color: rgba(29, 81, 102, 0.03);
  z-index: 1;
  transform: rotate(-15deg);
  pointer-events: none;
}

/* RTL Support */
[dir="rtl"] .report-card:hover .action-arrow {
  transform: translateX(-5px);
}

[dir="rtl"] .card-decoration {
  right: auto;
  left: -10px;
  transform: rotate(15deg);
}
</style> 

